var map = {
	"./ar-SA.md": 72454,
	"./be-BY.md": 31521,
	"./bg-BG.md": 47705,
	"./bn-BD.md": 37365,
	"./ca-ES.md": 71507,
	"./cs-CZ.md": 56636,
	"./da-DK.md": 79371,
	"./de-DE.md": 57713,
	"./el-GR.md": 16097,
	"./en-GB.md": 49211,
	"./en-US.md": 54102,
	"./es-ES.md": 34827,
	"./fi-FI.md": 82477,
	"./fr-FR.md": 63335,
	"./he-IL.md": 58079,
	"./hi-IN.md": 45622,
	"./hr-HR.md": 78555,
	"./hu-HU.md": 81161,
	"./id-ID.md": 36921,
	"./it-IT.md": 47097,
	"./ja-JP.md": 87982,
	"./km-KH.md": 83500,
	"./ko-KR.md": 19656,
	"./me-ME.md": 90860,
	"./mk-MK.md": 4667,
	"./ml-IN.md": 87,
	"./nb-NO.md": 62564,
	"./ne-NP.md": 37274,
	"./nl-NL.md": 70655,
	"./no-NO.md": 59633,
	"./pl-PL.md": 69819,
	"./pt-BR.md": 56987,
	"./pt-PT.md": 38475,
	"./pt-TL.md": 79623,
	"./ro-RO.md": 81225,
	"./ru-MD.md": 86977,
	"./ru-RU.md": 93421,
	"./sh-HR.md": 47676,
	"./si-LK.md": 2238,
	"./sk-SK.md": 47563,
	"./so-SO.md": 85267,
	"./sq-AL.md": 65162,
	"./sq-MK.md": 51427,
	"./sr-CS.md": 86874,
	"./sr-ME.md": 30998,
	"./sr-RS.md": 60167,
	"./sr-SP.md": 76675,
	"./sv-SE.md": 51911,
	"./tg-TJ.md": 2194,
	"./th-TH.md": 787,
	"./tk-TM.md": 27075,
	"./tr-TR.md": 27539,
	"./tu-TI.md": 12317,
	"./uk-UA.md": 5481,
	"./ur-PK.md": 35011,
	"./vi-VN.md": 23036,
	"./zh-CN.md": 55392,
	"./zu-ZA.md": 44601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65988;